/**
 * Histories slice (SCRUM-1951, RTK bundle 2) — the former switch reducer
 * historiesReducer.js as createSlice. Behaviour-preserving: every case answers
 * the same legacy action type string (historiesTypes.js) that historiesActions.js
 * already dispatches, and returns the same state. The actions module is
 * unchanged, so deleteHistory keeps its resolve/reject contract and no importer
 * changes. `CLEAR_MESSAGE` is the same string pendingPages answers to; each
 * slice clears its own message, as the two switch reducers did.
 * Characterised by tests/integration/reducers/reviewPublishingReducers.characterisation.test.js.
 */
import { createSlice } from "@reduxjs/toolkit";
import { legacyCases } from "../legacyCases";
import {
  GET_HISTORIES,
  CLEAR_MESSAGE,
  DELETE_HISTORY,
  CLEAR_HISTORY,
} from "./historiesTypes";
import type { MessageResponse } from "../../../../shared/apiTypes";

type HistoriesState = {
  histories: any[];
  message: string;
};

const initialState: HistoriesState = {
  histories: [],
  message: "",
};

const historiesCases = {
  [CLEAR_MESSAGE]: (state: HistoriesState) => ({ ...state, message: "" }),
  [GET_HISTORIES]: "histories" as const,
  [DELETE_HISTORY]: (state: HistoriesState, payload: MessageResponse) => ({
    ...state,
    message: payload.msg,
  }),
  [CLEAR_HISTORY]: (state: HistoriesState, payload: MessageResponse) => ({
    ...state,
    message: payload.msg,
  }),
};

const historiesSlice = createSlice({
  name: "histories",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    legacyCases(builder, historiesCases);
  },
});

export default historiesSlice.reducer;
